import { AbstractControl, ValidatorFn } from '@angular/forms';

export default function passwordRulesValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    if (control.value != null) {
      const password = control.value;
      return password.match(/[!@#$%^&*(){}[\]?~<>]/)
        && password.match(/[A-Z]/)
        && password.match(/[a-z]/)
        && password.match(/\d/)
        && password.length >= 8
        ? null
        : { passwordRules: true };
    } else {
      return null;
    }
  };
}



// WEBPACK FOOTER //
// ./src/validators/passwordRulesValidator.ts